import { CONSUMPTION_API, ORCHESTRATION_SERVICE_API } from '../constants/AppConstants';

/**
 * Service to fetch consumption/usage summary for a subscription or non-subscription
 * @param {string} orgId - The organization ID
 * @param {string} subscriptionId - The subscription ID (optional, omit for non-subscription)
 * @param {string} startDate - Subscription cycle start date (optional)
 * @param {string} endDate - Subscription cycle end date (optional)
 * @returns {Promise} - API response promise
 */
export default async (orgId, subscriptionId, startDate, endDate) => {
  try {
    let url;
    if (subscriptionId) {
      url = CONSUMPTION_API.replace(':orgId', orgId).replace(':subscriptionId', subscriptionId);
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append('startDate', startDate);
      if (endDate) queryParams.append('endDate', endDate);
      const queryString = queryParams.toString();
      if (queryString) url = `${url}?${queryString}`;
    } else {
      url = `${ORCHESTRATION_SERVICE_API}/v1/subscription/${orgId}/usage-summary`;
    }

    const response = await fetch(url);
    const json = await response.json();

    if (response.status !== 200) {
      return { ok: false, json };
    }
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
